// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2iU2f","box":"WorkspacesBox_box__15lfC","node":"WorkspacesBox_node__dnZm7"};